import { render, staticRenderFns } from "./ForumCategory.vue?vue&type=template&id=4744a3cc&"
import script from "./ForumCategory.vue?vue&type=script&lang=js&"
export * from "./ForumCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports